"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const t = require("io-ts");
const operators_1 = require("rxjs/operators");
const sok_types_1 = require("@caddigital/sok-types");
const _ActionTypes = require("./actionTypes");
const _Actions = require("./actions");
const ResponseHelpers = require("./helpers");
const errorHandling_1 = require("../../utils/errorHandling");
const ajax_1 = require("../../utils/ajax");
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const Actions = _Actions.default(namespace);
    function prevalidateFiles(action$, store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.PREVALIDATE_FILES_REQUEST), (0, operators_1.mergeMap)((payload) => ajax({
            headers: {
                'Content-Type': 'application/json',
                Authorization: getToken()
            },
            method: 'POST',
            body: Object.assign({}, payload.payload),
            url: `${baseUrl}api/order/validate`
        }).pipe((0, operators_1.mergeMap)(({ response }) => t
            .interface({
            valid: t.boolean,
            files: t.array(sok_types_1.Order.iOrderFile)
        })
            .decode(response)
            .fold((e) => ResponseHelpers.prevalidateFilesFailure(namespace, (0, errorHandling_1.parseValidationError)(e)), ResponseHelpers.requestRunner(namespace, payload, store, ResponseHelpers.prevalidateFilesSuccess, ResponseHelpers.prevalidateFilesFailure))), (0, operators_1.catchError)((error) => ResponseHelpers.prevalidateFilesFailure(namespace, (0, errorHandling_1.parseAjaxErrorResponse)(error))))));
    }
    function prevalidateImportedFiles(action$, store, { ajax, getToken, baseUrl }) {
        return action$.pipe((0, operators_1.filter)((action) => action.type === ActionTypes.PREVALIDATE_IMPORTED_FILES_REQUEST), (0, operators_1.mergeMap)((payload) => ajax({
            headers: (0, ajax_1.getHeaders)(getToken),
            method: 'POST',
            body: Object.assign({}, payload.payload),
            url: `${baseUrl}api/order/validate`
        }).pipe((0, operators_1.mergeMap)(({ response }) => {
            return t
                .interface({
                valid: t.boolean,
                files: t.array(sok_types_1.Order.iOrderFile)
            })
                .decode(response)
                .fold((e) => ResponseHelpers.prevalidateImportedFilesFailure(namespace, (0, errorHandling_1.parseValidationError)(e)), ResponseHelpers.requestRunner(namespace, payload, store, ResponseHelpers.prevalidateImportedFilesSuccess, ResponseHelpers.prevalidateImportedFilesFailure));
        }), (0, operators_1.catchError)((error) => ResponseHelpers.prevalidateImportedFilesFailure(namespace, (0, errorHandling_1.parseAjaxErrorResponse)(error))))));
    }
    return { prevalidateFiles, prevalidateImportedFiles };
}
exports.default = default_1;
//# sourceMappingURL=epics.js.map